import { render, staticRenderFns } from "./ServiceProviders.vue?vue&type=template&id=75adcad7&scoped=true"
import script from "./ServiceProviders.vue?vue&type=script&lang=ts"
export * from "./ServiceProviders.vue?vue&type=script&lang=ts"
import style0 from "./ServiceProviders.vue?vue&type=style&index=0&id=75adcad7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75adcad7",
  null
  
)

export default component.exports